import { CREDIT_CALCULATOR_URL } from '@/consts/urls';
import { getContext } from '@/context';
import getAuthJsonHeaders from '@/requests/common/getAuthJsonHeaders';

type Response = {
  status?: string;
  message?: string;
  response?: { result?: { usageAmount?: number } };
};

/**
 * Pure request — returns null on network failure or unexpected shape.
 */
const getProjectCredits = async ({
  webhookId,
}: {
  webhookId: string;
}): Promise<number | null> => {
  try {
    const response = await getContext().utils.api.fetch(CREDIT_CALCULATOR_URL, {
      method: 'POST',
      headers: getAuthJsonHeaders(),
      body: JSON.stringify({ params: { webhookId } }),
    });
    if (!response.ok) return null;
    const data: Response = await response.json();
    if (data.status === 'error') return null;
    return data.response?.result?.usageAmount ?? null;
  } catch {
    return null;
  }
};

export default getProjectCredits;
